// Dashboard
export const ROUTING_WELCOME = "/welcome";
export const ROUTING_FILTER_SECTION = "/filter-section";
export const ROUTING_CHATBOT = "/chatbot";

const ROUTES = {
  WELCOME: ROUTING_WELCOME,
  FILTER_SECTION: ROUTING_FILTER_SECTION,
  CHATBOT: ROUTING_CHATBOT
};

export default ROUTES;
